// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"372fd9ac","215":"3ecfc7cf","334":"976aae30","475":"8f869eb6","480":"8d735634"}[chunkId] + ".chunk.css";
};